// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__DF5ee","name":"ConsentHeader_name__5hdAO","birthday":"ConsentHeader_birthday__oIRyC","skeleton":"ConsentHeader_skeleton__3wxSk"};